/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".clickableSharedField_6ebc6df9{cursor:pointer}.clickableSharedField_6ebc6df9:hover{text-decoration:underline}.sharedFieldRender_6ebc6df9{text-decoration:none;text-overflow:ellipsis;overflow:hidden}\n"}]);
export const clickableSharedField = "clickableSharedField_6ebc6df9";
export const sharedFieldRender = "sharedFieldRender_6ebc6df9";